var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/helpers/extends", "classnames", "prop-types", "react", "../../Tracking", "../../UI/Icon/IconSvg"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/helpers/extends"), require("classnames"), require("prop-types"), require("react"), require("../../Tracking"), require("../../UI/Icon/IconSvg"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global._extends, global.classnames, global.propTypes, global.react, global.Tracking, global.IconSvg);
    global.SectionBreadcrumb = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _extends2, _classnames, _propTypes, _react, _Tracking, _IconSvg) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _extends2 = _interopRequireDefault(_extends2);
  _classnames = _interopRequireDefault(_classnames);
  _propTypes = _interopRequireDefault(_propTypes);
  _react = _interopRequireWildcard(_react);
  _IconSvg = _interopRequireDefault(_IconSvg);

  var SectionBreadcrumb = function SectionBreadcrumb(_ref) {
    var className = _ref.className,
        code = _ref.code,
        description = _ref.description,
        id = _ref.id,
        links = _ref.links,
        previous = _ref.previous,
        titleLevel = _ref.titleLevel,
        trackingSend = _ref.trackingSend;
    var textColorClass = code ? "next-color--".concat(code) : 'next-color--isWhite';
    var iconColorClass = code ? "icon-color--".concat(code) : 'icon-color--isWhite';

    if (previous && links.length === 1) {
      var _links$ = links[0],
          title = _links$.title,
          tracking = _links$.tracking,
          url = _links$.url;
      var onClick = tracking ? function () {
        return trackingSend(tracking);
      } : undefined;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('next-breadcrumb', className),
        id: id
      }, /*#__PURE__*/_react.default.createElement(titleLevel ? "h".concat(titleLevel) : 'div', {
        className: 'next-breadcrumb__main'
      }, /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('next-breadcrumb__icon', iconColorClass)
      }, /*#__PURE__*/_react.default.createElement(_IconSvg.default, {
        name: "arte-icon--previous2",
        size: "xsmall"
      })), /*#__PURE__*/_react.default.createElement("a", {
        href: url,
        title: title,
        className: (0, _classnames.default)('next-breadcrumb__category', "next-color--".concat(code), "icon-color--".concat(code)),
        onClick: onClick
      }, title))));
    }

    var NextIcon = /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('next-breadcrumb__icon', iconColorClass)
    }, /*#__PURE__*/_react.default.createElement(_IconSvg.default, {
      name: "arte-icon--next2",
      size: "xsmall"
    }));

    var AllLinks = links.map(function (_ref2, index) {
      var logo = _ref2.logo,
          title = _ref2.title,
          tracking = _ref2.tracking,
          url = _ref2.url;
      var onClick = tracking ? function () {
        return trackingSend(tracking);
      } : undefined;
      var logoAttributes = {};

      if (title !== '') {
        logoAttributes.title = title;
      }

      if (logo) {
        var LogoImg = /*#__PURE__*/_react.default.createElement("img", (0, _extends2.default)({
          className: "",
          src: logo,
          alt: title
        }, logoAttributes));

        return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
          key: "".concat(title, "-").concat(index)
        }, url ? /*#__PURE__*/_react.default.createElement("a", {
          className: (0, _classnames.default)('next-breadcrumb__logo', textColorClass),
          href: url,
          onClick: onClick
        }, LogoImg) : /*#__PURE__*/_react.default.createElement("div", {
          className: "next-breadcrumb__logo"
        }, LogoImg), url && NextIcon);
      }

      var isHighlighted = index === links.length - 1;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, {
        key: "".concat(title, "-").concat(index)
      }, url ? /*#__PURE__*/_react.default.createElement("a", {
        className: (0, _classnames.default)('next-breadcrumb__category', textColorClass, {
          'is-highlighted': isHighlighted
        }),
        href: url,
        onClick: onClick
      }, title) : /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('next-breadcrumb__category', textColorClass, {
          'is-highlighted': isHighlighted
        })
      }, title), url && NextIcon);
    });
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)('next-breadcrumb', className),
      id: id
    }, /*#__PURE__*/_react.default.createElement(titleLevel ? "h".concat(titleLevel) : 'div', {
      className: 'next-breadcrumb__main'
    }, AllLinks), description && /*#__PURE__*/_react.default.createElement("div", {
      className: "next-breadcrumb__description",
      title: description
    }, description));
  };

  SectionBreadcrumb.propTypes = {
    className: _propTypes.default.string,
    code: _propTypes.default.string,
    description: _propTypes.default.string,
    id: _propTypes.default.string,
    links: _propTypes.default.arrayOf(_propTypes.default.shape({
      logo: _propTypes.default.string,
      title: _propTypes.default.string,
      tracking: _propTypes.default.shape(),
      url: _propTypes.default.string
    })),
    titleLevel: _propTypes.default.number,
    previous: _propTypes.default.bool,
    trackingSend: _propTypes.default.func
  };
  SectionBreadcrumb.defaultProps = {
    code: '',
    description: '',
    links: [],
    previous: false,
    trackingSend: _Tracking.send
  };
  var _default = SectionBreadcrumb;
  _exports.default = _default;
});